import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiGift } from "react-icons/hi";
import { CustomButton } from "../../../atoms/CustomButton";
import { TrialActivationModal } from "../../../molecules/TrialActivationModal";
import { useTrialEligibility } from "../../../../hooks/promoCode/trial";

const TrialOfferBanner: React.FC = () => {
  const { t } = useTranslation();
  const { eligible } = useTrialEligibility();
  const [showConfirm, setShowConfirm] = useState(false);

  if (!eligible) return null;

  return (
    <div className="lg:col-span-12 col-span-1">
      <div className="w-full bg-white rounded-lg border border-gray-200 p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
          <HiGift className="w-5 h-5 text-blue-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-900 font-figtree">
            {t("dashboard.trialOffer.title")}
          </p>
          <p className="text-xs text-gray-500 font-figtree mt-0.5">
            {t("dashboard.trialOffer.subtitle")}
          </p>
        </div>
        <CustomButton
          variant="primary"
          size="sm"
          onClick={() => setShowConfirm(true)}
          title={t("dashboard.trialOffer.cta") as string}
          className="flex-shrink-0"
        />
      </div>

      <TrialActivationModal
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
      />
    </div>
  );
};

export default TrialOfferBanner;
